import React from "react";
import { StyleSheet, Text, View } from "react-native";

interface HomeIdentityItemProps {
  item: {
    nama: string;
    gender: string;
    ttl: string;
    alamat: string;
    activeMarriageTab: string;
    kewarganegaraan: string;
    educationTab: string;
    pendidikan: string;
  };
}

const AllIdentity = ({ item }: HomeIdentityItemProps) => {
  return (
    <View>
      <Text style={styles.allIdentityName}>
        {item.nama} <span>({item.gender === "Laki-Laki" ? "L" : "P"})</span>
      </Text>
      <Text style={styles.allIdentityText}>Tangal Lahir : {item.ttl}</Text>
      <Text style={styles.allIdentityText}>Alamat : {item.alamat}</Text>
      <Text style={styles.allIdentityText}>
        Status Perkawinan : {item.activeMarriageTab}
      </Text>
      <Text style={styles.allIdentityText}>
        Kewarganegaraan : {item.kewarganegaraan}
      </Text>
      <Text style={styles.allIdentityText}>
        Pendidikan :{" "}
        {item.educationTab === "Lain-lain"
          ? item.pendidikan
          : item.educationTab}
      </Text>
    </View>
  );
};

export default AllIdentity;

const styles = StyleSheet.create({
  allIdentityName: {
    fontSize: 24,
    fontWeight: "500",
    marginBottom: 5,
    marginTop: 50,
  },
  allIdentityText: {
    fontSize: 16,
    fontWeight: "500",
    marginBottom: 5,
  },
});
